import { DataTypeConfigUtils, QueryDefinition } from '@helo/cms'
import { flow, pipe } from '@helo/utils'

import { CmsSlice } from './cmsSlice'

const setupDataTypeConfigs = () =>
  flow(flow.inputExtends<CmsSlice>(), store => {
    const baseStateConfigs = pipe(
      store.cms.stateConfigs,
      DataTypeConfigUtils.prunedStateToStateConfig(store.cms.dataTypeConfigs),
    )

    const baseDataTypeConfigs = pipe(
      store.cms.dataTypeConfigs,
      DataTypeConfigUtils.createSelfComputingConfigs(baseStateConfigs),
    )

    return {
      ...store,
      cms: {
        ...store.cms,
        baseStateConfigs,
        baseDataTypeConfigs,
      },
    }
  })

const getQueryDefinition = (queryDefinitionId: string) =>
  flow(flow.inputExtends<CmsSlice>(), (store): QueryDefinition => {
    const queryDefinition = store.cms.queryDefinitions.find(
      qd => qd.id === queryDefinitionId,
    )
    if (!queryDefinition)
      throw new Error(`Query definition ${queryDefinitionId} not found`)
    return queryDefinition
  })

export const CmsSliceParts = {
  setupDataTypeConfigs,
  getQueryDefinition,
}
